module.exports = __webpack_public_path__ + "assets/2025-03-12-01.d0f38e00.pdf";